export function handleShelfIndex(shelfIndex) {
  return { type: "HANDLE_SHELF_INDEX", payload: shelfIndex };
}
export function handleCollapse(isCollapsed) {
  return { type: "HANDLE_COLLAPSE", payload: isCollapsed };
}
export function handleMode(mode) {
  return { type: "HANDLE_MODE", payload: mode };
}
